import { default as React, useEffect } from 'react';
import { pharmacyRequestHistorySummary } from '../Async/PharmacyRequestsAsync';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { useAsync } from '../Hooks/useAsync';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { HistorySummaryStatusColour, HistorySummaryTable } from '../HistorySummaryTable/HistorySummaryTable';
import styles from './PharmacyRequestHistorySummary.module.css';
import { ArrowLeftIcon, ErrorCircleIcon, SendIcon, StopHandIcon, TickIcon } from '../Components/Icons';
import { primaryBlue } from '../Styles/Colours';
import { LayoutCentral } from '../Components/LayoutCentral';
import { PharmacyRequestHistoryStatus } from '../Contracts/MedicationModels';
import { startCase } from 'lodash';
export var PharmacyRequestHistorySummary = function (props) {
    var _a, _b, _c;
    var httpConfig = useHttpConfig();
    var pharmacyRequestAsync = useAsync({
        httpConfig: httpConfig,
        defaultValue: { history: [] },
        getApi: pharmacyRequestHistorySummary
    });
    useEffect(function () {
        pharmacyRequestAsync.getApi(props.pharmacyRequestId);
    }, [props.pharmacyRequestId]);
    var pharmacyRequestHistory = pharmacyRequestAsync.data;
    function pharmacyRequestHistoryColour(status) {
        switch (status) {
            case PharmacyRequestHistoryStatus.Sent:
                return HistorySummaryStatusColour.Blue;
            case PharmacyRequestHistoryStatus.Stopped:
                return HistorySummaryStatusColour.Grey;
            case PharmacyRequestHistoryStatus.Cancelled:
            case PharmacyRequestHistoryStatus.EnteredInError:
            case PharmacyRequestHistoryStatus.Declined:
            case PharmacyRequestHistoryStatus.ElectronicFailure:
                return HistorySummaryStatusColour.Red;
            case PharmacyRequestHistoryStatus.Created:
            case PharmacyRequestHistoryStatus.Submitted:
            case PharmacyRequestHistoryStatus.Accepted:
                return HistorySummaryStatusColour.Green;
            default:
                return HistorySummaryStatusColour.Yellow;
        }
    }
    function pharmacyRequestHistoryIcon(status) {
        switch (status) {
            case PharmacyRequestHistoryStatus.Sent:
                return SendIcon;
            case PharmacyRequestHistoryStatus.Stopped:
                return StopHandIcon;
            case PharmacyRequestHistoryStatus.Cancelled:
            case PharmacyRequestHistoryStatus.EnteredInError:
            case PharmacyRequestHistoryStatus.Declined:
            case PharmacyRequestHistoryStatus.ElectronicFailure:
                return ErrorCircleIcon;
            case PharmacyRequestHistoryStatus.Created:
            case PharmacyRequestHistoryStatus.Submitted:
            case PharmacyRequestHistoryStatus.Accepted:
                return TickIcon;
            default:
                return null;
        }
    }
    function pharmacyRequestHistoryStatusText(status) {
        switch (status) {
            case PharmacyRequestHistoryStatus.EnteredInError:
                return 'Entered In Error';
            case PharmacyRequestHistoryStatus.ElectronicFailure:
                return 'Failed To Stop';
            default:
                return startCase(status !== null && status !== void 0 ? status : '');
        }
    }
    var contents;
    if (pharmacyRequestAsync.loadCount === 0 || pharmacyRequestAsync.data === null) {
        contents = (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    }
    else {
        contents = (React.createElement("div", null,
            React.createElement("div", { className: styles.requestNumberText }, ((_a = props.pharmacyRequestTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) + " #" + props.pharmacyRequestNumber),
            React.createElement("div", null,
                React.createElement(HistorySummaryTable, { historyItems: (pharmacyRequestHistory === null || pharmacyRequestHistory === void 0 ? void 0 : pharmacyRequestHistory.history)
                        ? pharmacyRequestHistory.history.map(function (it) { return ({
                            statusColour: pharmacyRequestHistoryColour(it.status),
                            statusText: pharmacyRequestHistoryStatusText(it.status),
                            statusIcon: pharmacyRequestHistoryIcon(it.status),
                            source: it.source,
                            changedOn: it.changedOn,
                            changedBy: it.changedBy,
                            newValue: it.newValue
                        }); })
                        : [] }))));
    }
    var summaryContents = (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.return },
            React.createElement(ArrowLeftIcon, { color: primaryBlue, noPadding: true, onClick: props.onCloseHistoryClicked }),
            React.createElement("span", { className: styles.returnText, onClick: props.onCloseHistoryClicked },
                "Back to ", (_c = (_b = props.pharmacyRequestTerm) === null || _b === void 0 ? void 0 : _b.pluralTerm) === null || _c === void 0 ? void 0 :
                _c.toLowerCase())),
        React.createElement("div", null, contents)));
    return summaryContents;
};
